import { render, staticRenderFns } from "./ModalTestMessage.vue?vue&type=template&id=134ecfa0&"
import script from "./ModalTestMessage.vue?vue&type=script&lang=js&"
export * from "./ModalTestMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports